<template>
    <div class="page__tabs">
		<div :class="'page__tabs__pos page__tabs__pos--' + index" v-for="(pos, index) in positions" :key="index">
			<div :class="'page__tabs__item' + ($route.name == item.name ? ' page__tabs__item--active' : '')" v-for="item in pos" :key="item.name" @click="$emit('itemClick', item.name)">
				<svgicon :icon="item.icon" class="page__tabs__item__icon" />
				<div class="page__tabs__item__label">{{ item.label }}</div>
				<div class="page__tabs__item__marker" />
				<div class="page__tabs__item__badge">{{ item.badge }}</div>
			</div>
		</div>
    </div>
</template>

<script>
    export default {
		props: ['items'],
		watch: {
			'item.badge': function (val, oldVal) {
				console.log(`Changed from ${oldVal} to ${val}`);
			}
		},
		computed: {
			positions() {
				var pos = {};
				var prop;
				var item;

				for (var i in this._pages) {
					item = this._pages[i];
					prop = item.hasOwnProperty('pos') ? item.pos : 'default';

					if (pos.hasOwnProperty(prop)) {
						pos[prop].push(item);
					} else {
						pos[prop] = [item];
					}
				}

				return pos;
			},
			_pages() {
				var r = [];

				for (var i = 0; i < this.items.length; ++i) {
					var item = this.items[i];

					if (!this.$store.state.employee.privileges || !this.$store.state.employee.privileges[item.name]) {
						continue;
					}

					r.push(item);
				}

				return r;
			}
		}
    }
</script>

<style lang="scss">
	.page__tabs {
		overflow: hidden;
		display: block;
		float: left;
		margin-left: 50px;

		&__item {
			width: auto;
			cursor: pointer;
			display: block;
			float: left;
			position: relative;
			height: 80px;
			padding: 0 30px 0 30px;

			&__badge {
				display: none;
			}

			&__icon {
				position: absolute;
				left: 25px;
				top: 20px;
				width: 20px;
				height: 20px;
				line-height: 60px;	
				text-align: center;	
				transition: all 250ms;
			}

			&:hover &__icon, &--active &__icon {
				fill: white;
			}

			&__label {
				line-height: 80px;
				color: black;
			}

			&__marker {
				position: absolute;
				left: 0;
				height: 0;
				bottom: 0;
				width: 100%;
				background-color: #f7223f;
				transition: all 250ms;
				opacity: 0;
			}

			&--active &__marker {
				height: 4px;
				opacity: 1;
			}
		}
	}
</style>